import actions from "./moduleS3ServiceAction";

export default {
  namespaced: true,
  actions: actions
};
